import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDmkNrhy_jgq-ydbfGKtJC8qX8pknRiP-0",
  authDomain: "leads-maps-pro.firebaseapp.com",
  projectId: "leads-maps-pro",
  storageBucket: "leads-maps-pro.firebasestorage.app",
  messagingSenderId: "396634272585",
  appId: "1:396634272585:web:d21ae92682b2034470e098",
  measurementId: "G-CP6PYZVN0V"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export { doc, setDoc, getDoc, ref, uploadBytes, getDownloadURL };
export default app;
